import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import store from "store";
import Home from "pages/home";
import loadable from "utils/loadable.js";
import Header from "common/header";
import { Footer  } from "common/footer";

// bootstrap
import Container from 'react-bootstrap/Container';

function App() {
  const Detail = loadable(() => import("pages/detail"));
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Container>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/detail/:id" element={<Detail />} />
          </Routes>
          <Footer />
        </Container>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
